import { WithdrawForm } from "@/components/WithdrawForm";

export default function WithdrawPage() {
  return (
    <div className="w-full max-w-3xl mx-auto py-10 px-4">
      <WithdrawForm />
    </div>
  );
}
